'use client';

import React, { useEffect } from 'react';

import { Resolution } from '@blockscout/stats-types';
import type { StatsIntervalIds } from 'types/client/stats';

import useChartQuery from 'src/hooks/useChartQuery';

import ChartWidget from 'src/components/chart/ChartWidget';

type Props = {
  id: string;
  title: string;
  description: string;
  units?: string;
  interval: StatsIntervalIds;
  onLoadingError: () => void;
  isPlaceholderData: boolean;
  className?: string;
  href?: string;
  headerExtra?: React.ReactNode;
};

const ChartWidgetContainer = ({
  id,
  title,
  description,
  interval,
  onLoadingError,
  units,
  isPlaceholderData,
  className,
  href,
  headerExtra,
}: Props) => {
  const { items, lineQuery } = useChartQuery(
    id,
    Resolution.DAY,
    interval,
    !isPlaceholderData,
  );

  useEffect(() => {
    if (lineQuery.isError) {
      onLoadingError();
    }
  }, [ lineQuery.isError, onLoadingError ]);

  return (
    <ChartWidget
      isError={ lineQuery.isError }
      items={ items }
      title={ title }
      units={ units }
      description={ description }
      isLoading={ lineQuery.isPlaceholderData }
      className={ className }
      href={ href }
      headerExtra={ headerExtra }
    />
  );
};

export default ChartWidgetContainer;
